<template>
<div>

	<div class="userInfo">
		<div class="img center"><el-link :underline="false" @click.native="$router.push('/');" style="    font-size: 1.5rem;
    font-weight: bold;"> FASCISM</el-link></div>
		<div class="txt1 center">{{ getName }}</div>
		<!-- <div class="txt3 left">帳號等級: {{ getClass }}</div>
		<div class="txt2 left">帳號安全:<el-rate class="block-rate" v-model="getRate" disabled :text-color="getColor" disabled-void-color="#c0c4cc"></el-rate></div> -->
		<div class="txt1 center">
							<div>銀行帳戶</div>
							<div v-if="user.bank.bank_account" style="font-size: 0.9rem;">
									銀行: {{user.bank.bank_value}}
									<br>
									戶名: {{user.bank.bank_username}}
									<br>
									帳號: {{user.bank.bank_account | markaccount}}
							</div>
							<div v-else>
								<el-button type="text" @click="go2page('/user/set-bank')" class="btn-user"  style="text-decoration:underline;">
									<span >綁定銀行帳戶</span>
								</el-button>
							</div>
							<div>
								<el-button type="text" @click="go2page('/user/password')" class="btn-user"  style="text-decoration:underline;">
									<span >修改登錄密碼</span>
								</el-button>
							</div>
							<!-- <div>
								<el-button type="text" @click="go2page('/user/reset-cashpassword')" class="btn-user"  style="text-decoration:underline;">
									<span >重設提領密碼</span>
								</el-button>
							</div> -->
							<div>
								<el-button type="text" @click="go2page('/')" class="btn-user"  style="text-decoration:underline;">
									<span >回首頁</span>
								</el-button>
							</div>
		</div>
	</div>

	<el-menu  @select="handleSelect" @close="handleClose" :router="true">

		<!-- <el-menu-item index="/user/wallet">資產總覽<i class="el-icon-arrow-right pull-right"></i></el-menu-item> -->
		<!-- <el-menu-item index="/user/deposit"><i class="fas fa-adjust menu_icon" ></i> 存款專區</el-menu-item>
		<el-menu-item index="/user/withdraw"><i class="fas fa-archive menu_icon" ></i> 提款專區</el-menu-item>
		<el-menu-item index="/user/transfer-log"><i class="fas fa-book-open menu_icon" ></i> 對帳單查詢</el-menu-item>
		<el-menu-item index="/user/bet-log" ref="betlog"><i class="fas fa-briefcase menu_icon" ></i> 演算查詢</el-menu-item> -->
		<!-- <el-menu-item index="/user/info">個人資料<i class="fas fa-grin-alt menu_icon" ></i></el-menu-item> -->
		<!-- <el-menu-item index="/user/mail">
				<i class="fas fa-bullhorn menu_icon" ></i> 站內消息
		</el-menu-item> -->
		<!-- <el-menu-item @click="service()">聯絡客服<i class="fas fa-headset" style="color:#52c570;font-size: 20px;margin-left: 80px;"></i></el-menu-item> -->
		<el-menu-item @click.native="logout()"> [ 系統登出 <i class="fas fa-arrow-circle-right" ></i> ]</el-menu-item>
		<el-menu-item @click.native="service()"> [ 聯絡客服 <i class="fas fa-headset" ></i> ]</el-menu-item>
		<!-- <el-menu-item index="/user/dzp">
			<el-badge :value="user.dzp_chance" :hidden="user.dzp_chance == 0" class="dot-number">
				幸運大轉盤
			</el-badge>
			<i class="el-icon-arrow-right pull-right"></i>
		</el-menu-item> -->
	</el-menu>

	<!-- <div class="menu-bottom">
		<div class="center" style="padding:20px; 0px">
			<div style="color:#eaeaea;margin:10px;cursor: pointer;" @click="service()">聯絡客服</div>
			<VueQr :text="config.CustomerServiceUrl" :size="120"></VueQr>
			<div @click="service()"  style="color:#eaeaea;cursor: pointer;"><img src="~assets/images/photo1639816629.jpeg" width="164" height="164"></div>
		</div>
	</div> -->

</div>
</template>
<script>
import VueQr from 'vue-qr'
import { mapGetters } from 'vuex'
export default {
	methods: {
		logout() {
			this.$emit('LoginBox',{methods:'logout'});
		},		
		service()
		{
			window.open(this.config.CustomerServiceUrl,'', 'height=500,width=500,location=no,menubar=no,menubar=no');
		},		
        go2page(page){
            let cmd = page;
			//this.user.currentRoute = cmd;
			this.$router.push({path: cmd, query: {}});
        },
	  handleSelect(key, keyPath) {
		this.user.currentRoute = '';
	  },
	  handleClose(key, keyPath) {
	    console.log(key, keyPath);
	  }
	},
	filters: {
		markaccount: function (value) {
			if (!value) return ''
			if (value.length < 5) return ''
			let temp = value.substr(0,value.length-5)
			//value = value.toString()
			return temp+"*****"
		}
	},	
    computed: {
		...mapGetters({
			user: 'user',
			config : 'config',
		}),
			getRate(){
					let rate = 1;
					if(this.user.mobile)    rate++;
					if(this.user.bank.bank_account)  rate++;
					if(this.user.is_cash_password)  rate++;
					if(this.user.name)  rate++;
					return rate;
			},
			getColor(){
					let rate = this.getRate;

					let col = '#FF0000';
					if(rate > 2)    col = '#4091FF';
					if(rate > 4)    col = '#67c23a';
					return col;
			},
			getName(){
				return this.user.username;
				//	if(this.user.name)  return this.user.name;
				//	return "會員";
			},
			getClass(){
				return this.config.class[this.user.class];
				/*
				if(this.user.class==0) return '一般會員';
				if(this.user.class==1) return '黃金會員';
				if(this.user.class==2) return '白金會員';
				if(this.user.class==3) return '鑽石會員';*/
			}
    },
	created(){
		this.user.currentRoute = this.$router.currentRoute.path;
	},
	components: {
		VueQr
	},
	data() {
		return {
			//activeIndex: this.$router.currentRoute.path,
		};
	},


}
</script>
<style>
.left-column .dot-number .el-badge__content.is-fixed{
	top:21px;
	right:-6px;
}
.left-column .userInfo .img .avatar {
    width: 89px;
    height: 89px;
    display: block;
    border-radius: 100%;
    border: 8px solid #e7e3e3;
    margin: auto;
    background: #fff url(~assets/images/logo-small.png) no-repeat;
    background-size: 118%;
    background-position: 50%;
}
.left-column .userInfo {

	padding:32px 24px 24px 24px;
	    border-right: solid 1px #888;

}
.left-column .userInfo .txt1 {
    margin-top: 14px;
    color: #ddd;
    font-size: 16px;
    font-weight: 700;
}
.left-column .userInfo .txt2 {
    margin-top: 14px;
    font-size: 14px;
	    color: #ddd;
}
.left-column .userInfo .txt3 {
    margin-top: 14px;
    font-size: 14px;
	color: #ddd;
}
.left-column .menu-bottom {

	border-right: 1px solid #888;
	margin-bottom: -100000px;
	padding-bottom:100000px;

}

.block-rate{
    display: inline;
    line-height: 12px;
}
.el-rate__icon{
  margin-right: 0px !important;
}

.left-column .el-badge__content.is-fixed {
  top: 10px;
  right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/user/Menu.vue